function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { useState } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import useTheme from "../hooks/useTheme";
import { responsiveMarginType } from "../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { responsiveMargin } from "../utils/css";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t07"];
var DEFAULT_PROPS = {
  color: "grey.t07"
};
Divider.DEFAULT_PROPS = DEFAULT_PROPS;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "ligvgk",
  styles: "transform:translateX(-4px);width:calc(100% + 4px);height:100%;"
} : {
  name: "ligvgk",
  styles: "transform:translateX(-4px);width:calc(100% + 4px);height:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function Divider(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);
  var color = props.color,
    testId = props.testId;
  var _useState = useState(function () {
      return "divider-".concat(nanoid());
    }),
    _useState2 = _slicedToArray(_useState, 1),
    patternId = _useState2[0];
  var theme = useTheme();
  var circleColor = theme.getColor(color);
  var responsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    margin: responsiveMargin
  });
  return ___EmotionJSX("svg", {
    css: responsiveCSS,
    width: "100%",
    height: "24",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("pattern", {
    id: patternId,
    x: "0",
    y: "0",
    width: "15",
    height: "24",
    patternUnits: "userSpaceOnUse"
  }, ___EmotionJSX("circle", {
    cx: "3",
    cy: "3",
    r: "3",
    fill: circleColor
  }), ___EmotionJSX("circle", {
    cx: "10.5",
    cy: "12",
    r: "3",
    fill: circleColor
  }), ___EmotionJSX("circle", {
    cx: "3",
    cy: "21",
    r: "3",
    fill: circleColor
  })), ___EmotionJSX("rect", {
    css: _ref,
    x: "0",
    y: "0",
    fill: "url(#".concat(patternId, ")")
  }));
}
Divider.propTypes = _objectSpread(_objectSpread({}, responsiveMarginType), {}, {
  color: PropTypes.oneOf(COLORS),
  testId: PropTypes.string
});
export default Divider;